import React from "react";
import './TextField.scss';

type TextFieldProps = {
    className?: string,
    label?: string,
    value: string|number,
    placeholder?: string,
    autocomplete?: string,
    type?: 'text'|'number'|'password'|'time',
    min?: number,
    max?: number,
    step?: number,
    maxlength?: number,
    style?: 'primary'|'secondary',
    disabled?: boolean,
    uppercase?: boolean,
    onChange: (value: string) => void,
};

function TextField(props: TextFieldProps) {

    return (
        <div className={`textfield ${props.className ?? ''} style-${props.style ?? 'primary'}`}>
            {props.label && (
                <span className="textfield-label">{props.label}</span>
            )}
            <input
                type={props.type ?? 'text'}
                min={props.min}
                max={props.max}
                step={props.step}
                maxLength={props.maxlength}
                className={`${props.uppercase ? 'uppercase' : ''}`}
                value={props.value}
                placeholder={props.placeholder ?? ''}
                autoComplete={props.autocomplete}
                disabled={props.disabled}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.onChange(e.target.value)}/>
        </div>
    );
}

export default TextField;
